<div class="mb-5 w-100">
  <div *ngIf="!inEditMode" class="f-14 text-484b59 font-weight-600">Add new Contact</div>
  <div *ngIf="inEditMode" class="f-14 text-484b59 font-weight-600">Edit Contact</div>

  <div class="add-contact">
    <form action="" [formGroup]="masterForm">

      <!-- professional -->
      <div *ngIf="!inEditMode || (editInfo.type === 'professional')" formGroupName="professionalForm">
        <label for="professional-email">Professional Email ID</label>
        <div class="professional" *ngFor="let FC of formLength('professional'); let i = index">
          <div [formGroupName]="FC">
            <div class="d-flex align-items-center">
              <input data-testid="auto-app-add-contact-details-slider-input-1" placeholder="Enter Professional Email ID" formControlName="email">
              <span *ngIf="i!=0" class="deleteFormBtn" (click)="deleteFormControl('professional',FC)"><i
                  class="fa-regular fa-trash" style="color: #969696;"></i></span>
            </div>
            <span class="d-flex justify-content-between align-items-sm-start">
              <span class="d-flex flex-column">
                <span class="d-flex flex-column">
                  <span class="errorMessage" *ngIf="masterFormErrors('professional',FC).hasError('pattern') && masterFormErrors('professional',FC).touched">Enter valid Professional Email.</span>
                  <span class="errorMessage" *ngIf="masterForm.get('professionalForm').hasError('required') && !masterFormErrors('professional',FC).value && i==0">This field cannot be empty.</span>
                  <span class="errorMessage" *ngIf="duplicateValueErrors('professional',FC).hasError('duplicate') && masterFormErrors('professional',FC).touched">Duplicate values not allowed  .</span>
                  <span class="errorMessage" *ngIf="masterForm.get('professionalForm').hasError('required') && !masterFormErrors('professional',FC).value && i>0">This field cannot be empty, either delete or enter email id.</span>
                </span>
                <span *ngIf="!inEditMode" class="addAnotherContact" (click)="addNewRow('professional')">Add another Professional Email ID</span>
              </span>
              <span class="d-flex flex-row align-items-center mt-2 mb-2" style="margin-right: 35px;">
                <input data-testid="auto-app-add-contact-details-slider-input-2" class="mr-1" type="checkbox" (input)="checkboxManage('professional', FC)" formControlName="isprimary">
                <span style="text-wrap: nowrap;">Mark this as Primary</span>
              </span>
            </span>
          </div>
        </div>
        <p *ngIf="masterForm.controls.professionalForm.hasError('missingPrimary')" class="errorMessage m-0"> Please mark 1 Professional Email as primary </p>
      </div>

      <!-- Personal email -->
      <div *ngIf="!inEditMode || (editInfo.type === 'personal')" formGroupName="personalForm">
        <label for="personal-email">Personal Email ID</label>
        <div class="personal" *ngFor="let FC of formLength('personal'); let i = index">
          <div [formGroupName]="FC">
            <div class="d-flex align-items-center">
              <input data-testid="auto-app-add-contact-details-slider-input-3" placeholder="Enter personal Email ID"
                formControlName="email">
              <span *ngIf="i!=0" class="deleteFormBtn" (click)="deleteFormControl('personal',FC)"><i
                  class="fa-regular fa-trash" style="color: #969696;"></i></span>
            </div>
            <span class="d-flex justify-content-between align-items-sm-start">
              <span class="d-flex flex-column">
                <span class="d-flex flex-column">
                  <span class="errorMessage" *ngIf="masterFormErrors('personal',FC).hasError('pattern') && masterFormErrors('personal',FC).touched">Enter valid Personal Email.</span>
                  <span class="errorMessage" *ngIf="masterForm.get('personalForm').hasError('required') && !masterFormErrors('personal',FC).value && i==0">This field cannot be empty.</span>
                  <span class="errorMessage" *ngIf="duplicateValueErrors('personal',FC).hasError('duplicate') && masterFormErrors('personal',FC).touched">Duplicate values not allowed  .</span>
                  <span class="errorMessage" *ngIf="masterForm.get('personalForm').hasError('required') && !masterFormErrors('personal',FC).value && i>0">This field cannot be empty, either delete or enter email id.</span>
                </span>
                <span *ngIf="!inEditMode" class="addAnotherContact" (click)="addNewRow('personal')">Add another Personal Email ID</span>
              </span>
              <span class="d-flex flex-row align-items-center mt-2 mb-2" style="margin-right: 35px;">
                <input data-testid="auto-app-add-contact-details-slider-input-4" class="mr-1" type="checkbox" (input)="checkboxManage('personal', FC)" formControlName="isprimary">
                <span style="text-wrap: nowrap;">Mark this as Primary</span>
              </span>
            </span>
          </div>
        </div>
        <p *ngIf="masterForm.controls.personalForm.hasError('missingPrimary')" class="errorMessage m-0"> Please mark 1 Professional Email as primary</p>
      </div>

      <!-- contact number -->
      <div *ngIf="!inEditMode || (editInfo.type === 'contact_number')" formGroupName="contactForm">
        <label for="contact-number">Contact Number</label>
        <div class="contactnumber" *ngFor="let FC of formLength('contact_number'); let i = index">
          <div [formGroupName]="FC">
            <div class="d-flex align-items-center">
              <!-- <input data-testid="auto-app-add-contact-details-slider-input-5" placeholder="Enter Contact Number"
                formControlName="email"> -->
                <ngx-intl-tel-input [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                      [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                      [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="25"
                     [phoneValidation]="true"
                      name="email" formControlName="email" class="f-12" style="width: 95%;" >
                    </ngx-intl-tel-input>
              <span *ngIf="i!=0" class="deleteFormBtn" (click)="deleteFormControl('contact_number',FC)"><i
                  class="fa-regular fa-trash" style="color: #969696;"></i></span>
            </div>
            <span class="d-flex justify-content-between align-items-sm-start">
              <span class="d-flex flex-column">
                <span class="d-flex flex-column">
                  <span class="errorMessage" *ngIf="masterFormErrors('contact_number',FC).hasError('validatePhoneNumber') && masterFormErrors('contact_number',FC).touched">Enter valid Contact Number.</span>
                  <span class="errorMessage" *ngIf="masterForm.get('contactForm').hasError('required') && !masterFormErrors('contact_number',FC).value && i==0">This field cannot be empty.</span>
                  <span class="errorMessage" *ngIf="duplicateValueErrors('contact_number',FC).hasError('duplicate') && masterFormErrors('contact_number',FC).touched">Duplicate values not allowed  .</span>
                  <span class="errorMessage" *ngIf="masterForm.get('contactForm').hasError('required') && !masterFormErrors('contact_number',FC).value && i>0">This field cannot be empty, either delete or enter contact number.</span>
                </span>
                <span *ngIf="!inEditMode" class="addAnotherContact" (click)="addNewRow('contact_number')">Add another Contact Number</span>
              </span>
              <span class="d-flex flex-row align-items-center mt-2 mb-2" style="margin-right: 35px;">
                <input data-testid="auto-app-add-contact-details-slider-input-6" class="mr-1" type="checkbox" (input)="checkboxManage('contact_number', FC)" formControlName="isprimary">
                <span style="text-wrap: nowrap;">Mark this as Primary</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </form>

  </div>

  <!-- Cancel and Submit button -->
  <div class="d-flex justify-content-end mt-4" style="margin-right: 5%;">
    <button data-testid="auto-app-add-contact-details-slider-button-1" class="btn-trms-white mr-2" style="
    width: 108px;
    height: 31px;" (click)="!isLoadingAddContact && closeComponent()"> Cancel </button>

    <button data-testid="auto-app-add-contact-details-slider-button-2" class="btn-trms-small" style="
      width: 108px;
      height: 31px;" (click)="!isLoadingAddContact && submitDetails()">
      <span *ngIf="!isLoadingAddContact">
        {{(inEditMode) ? 'Update' : 'Add'}}
      </span>
      <span *ngIf="isLoadingAddContact">
        <img style="width: 20px;" src="../../assets/rolling-loader-white.gif" alt="">
      </span>
    </button>
  </div>

  <hr class="mt-5 mb-5">
</div>
